const initialState = { associatedContacts: {} };

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    // TODO sync with backend changes
    if (
        (action.type === 'COMPANY_CONTACT_INFO_SUCCESS' ||
            action.type === 'SAVE_COMPANY_CONTACT_INFO_SUCCESS') &&
        action.payload
    ) {
        return {
            ...state,
            [action.payload.companyId]: { ...action.payload },
        };
    }

    if (action.type === 'COMPANY_ASSOCIATED_CONTACTS_INFO_SUCCESS') {
        return {
            ...state,
            associatedContacts: {
                [action.actionParams.id]: action.payload,
            },
        };
    }

    return state;
}

export default reducer;
